import React from "react";
import { DataTableHeaderCell } from "src/components";

export const Header = ({ headings, onSort, onMainCheck, isSortable }) => {
    return (
        <tr>
            {headings.map((heading, index) => (
                <DataTableHeaderCell key={index}
                    style={{
                        zIndex: 1,
                        textAlign: heading.textAlign ? heading.textAlign : "left",
                        width: [0].includes(index) ? "1rem" : "auto",
                        cursor: isSortable(index) ? "pointer" : "auto",
                    }}
                    {...(index > 0 ? { onClick: () => onSort(index) } : {})}
                >
                    {index === 0 ? (
                        <label
                            style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                            onClick={(e) => {
                                e.preventDefault();
                                onMainCheck();
                            }}
                        >
                            {heading.name}
                        </label>
                    ) : (
                        heading.name
                    )}
                </DataTableHeaderCell>
            ))}
        </tr>
    );
};
